import { combineReducers } from "redux";
import { analyticsReducer } from "./analytics";
import { appReducer } from "./app";

export const rootReducer = combineReducers({
  analytics: analyticsReducer,
  app: appReducer,
});
